import React from 'react';
import { calculateStarRatingTier } from '../../domain/constants';
import { useUI } from '../../contexts/UIContext';
import './RatingBadge.css';

interface RatingBadgeProps {
    rating: number;
    leagueName: string;
}

export const RatingBadge: React.FC<RatingBadgeProps> = ({ rating, leagueName }) => {
    const { openRatingInfoModal } = useUI();
    const tier = calculateStarRatingTier(rating);
    const title = `Star Rating: ${rating.toFixed(1)}/5.0 (${tier.description}). Click for more info.`;

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        openRatingInfoModal(leagueName, rating);
    };

    return (
        <button className="rating-badge-button" onClick={handleClick} title={title}>
            <span className={`rating-badge ${tier.className}`}>
                {tier.label}
            </span>
        </button>
    );
};
